import React from 'react';
import * as S from './styled';
import ProgressBar from '../ProgressBar';

const NavigationInfo = ({ pageAmount = 4, currentPage }) => (
  <S.InfoWrapper className="NavigationInfo">
    <S.TextWrapper>{`Passo ${currentPage} de ${pageAmount}`}</S.TextWrapper>
    <ProgressBar
      current={currentPage}
      total={pageAmount}
      data-testid="navigation-progress"
    />
  </S.InfoWrapper>
);
export default NavigationInfo;
